const AccountStepsEN = {
  AccountSteps: {
    TITLE: ' will invest in you!',
    TEXT_1: 'We automatically create an ',
    ACCOUNT: 'ad account ',
    TOOLTIP: 'Payment management site for the content you sponsor!',
    TEXT_2_1: 'for your business. ',
    TEXT_2_2: ' will make resources available for you to boost your publications.',
  },
};

const AccountStepsPT = {
  AccountSteps: {
    TITLE: ' vai investir em você!',
    TEXT_1: 'Criamos automaticamente uma ',
    TEXT_2_1: 'para seu negócio. ',
    TEXT_2_2: ' disponibilizará recursos para que você impulsione suas publicações.',
    ACCOUNT: 'conta de anúncios ',
    TOOLTIP: 'Local de gerenciamento de pagamentos dos conteúdos patrocinados por você!',
  },
};

export { AccountStepsPT, AccountStepsEN };
